window._zyppy = {
  tracks: [],
  track: function(event, properties) {
    if(!event) return
    properties = properties || {}
    if(window.analytics) {
      analytics.track(event, properties)
    }
    if(window.zaraz) {
      zaraz.track(event, properties)
    }
    window._zyppy.tracks.push(event)
  },
  trackOnce(event, properties) {
    if(!window._zyppy.tracks.includes(event)) {
      window._zyppy.track(event, properties)
    }
  },
  identify: function(userId, traits) {
    if(!userId) return
    if(window.analytics) {
      analytics.identify(userId, traits)
    }
    if(window.clarity) {
      window.clarity('identify', userId)
      Object.entries(traits || []).forEach(([key, value]) => {
        window.clarity('set', key, (value || true).toString())
      })
    }
    if(window.zaraz) {
      traits.userId = userId
      zaraz.track('identify', traits)
      Object.entries(traits || []).forEach(([key, value]) => {
        zaraz.set(key, value)
      })
    }
  },
  page: function(name) {
    if(window.analytics) {
      analytics.page(name)
    }
  },
  alias: function({old}) {},
}